import * as yup from 'yup';
import { RootStore } from './root';
import { HttpMethod, PaginatedList } from '../types';

const YupGrant = yup.object({
    id: yup.number().required(),
    clientId: yup.number().required(),
    cnt: yup.number().required(),
    client: yup
        .object({
            id: yup.number().required(),
            firstName: yup.string().notRequired(),
            lastName: yup.string().notRequired(),
            fullName: yup.string().notRequired(),
            gender: yup.string().nullable(),
            language: yup.string().nullable(),
            email: yup.string().nullable(),
            appTargets: yup.array(yup.string().required()).default([]),
        })
        .required(),
});

const YupPaginatedGrantList = yup.object({
    page: yup.number().required(),
    perPage: yup.number().required(),
    total: yup.number().required(),
    results: yup.array(YupGrant).default([]),
});

export type Grant = yup.InferType<typeof YupGrant>;

export class PromotionGrantStore {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    /**
     * Fetch paginated grants associated with a promotion
     *
     * @param this
     * @param promotionId
     * @param page
     * @param perPage
     */
    async fetchGrantsPaginated(
        this: PromotionGrantStore,
        promotionId: number,
        page: number,
        perPage: number
    ): Promise<PaginatedList<Grant>> {
        const response = await this.rootStore.makeNetworkCall(
            {
                method: HttpMethod.GET,
                url: `/promotion-grants?promotionId=${promotionId}&page=${page}&perPage=${perPage}`,
            },
            YupPaginatedGrantList
        );

        if (response.data) {
            return {
                page: response.data.page,
                perPage: response.data.perPage,
                total: response.data.total,
                results: response.data.results,
            };
        } else {
            throw response.err;
        }
    }

    /**
     * Fetch all grants associated with a promotion (for download)
     * Uses all=true parameter to get all results regardless of pagination
     *
     * @param this
     * @param promotionId
     */
    async fetchAllGrants(
        this: PromotionGrantStore,
        promotionId: number
    ): Promise<Grant[]> {
        const response = await this.rootStore.makeNetworkCall(
            {
                method: HttpMethod.GET,
                url: `/promotion-grants?promotionId=${promotionId}&all=true`,
            },
            YupPaginatedGrantList
        );

        if (response.data) {
            return response.data.results;
        } else {
            throw response.err;
        }
    }
}
